/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography, Dialog } from "@material-ui/core";

/* Data Imports */

import AppConfig from "../../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  testimonialIcon: {
    borderRadius: "50%",
    height: "6.25rem",
    width: "6.25rem",
  },
  youtubeIcon: {
    height: "3.125rem",
    width: "3.125rem",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  playIcon: {
    height: "3.125rem",
    width: "3.125rem",
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  testimonialTitle: {
    fontWeight: 500,
    fontSize: "2.125rem",
    lineHeight: "3.1875rem",
    textAlign: "center",
    margin: "1rem 0rem 1rem 0rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  testimonialSubtitle: {
    color: "#666666",
    fontWeight: 400,
    fontSize: "1.125rem",
    lineHeight: "1.6875rem",
    width: "66.67%",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      letterSpacing: "0.016rem",
      width: "100%",
    },
    textAlign: "center",
  },
  overlayContainer: {
    position: "relative",
    borderRadius: "50%",
    height: "6.25rem",
    width: "6.25rem",
    boxShadow:
      "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    "&:hover $overlay": {
      transition: "opacity 0.25s",
      opacity: 1,
      cursor: "pointer",
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: "50%",
    height: "6.25rem",
    width: "6.25rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    background: "rgba(0,0,0)",
    background: "rgba(0,0,0,0.5)",
    transition: "0.25s ease",
    opacity: 0,
    [theme.breakpoints.down("md")]: {
      background: "rgba(0,0,0,0.25)",
      opacity: 1,
    },
    color: "#ffffff",
  },
  videoSizer: {
    width: "37.5rem",
    height: "21.09375rem",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      height: "7.59375rem",
      width: "13.5rem",
      backgroundSize: "120px 120px",
    },
    [theme.breakpoints.only("xs")]: {
      height: "9rem",
      width: "16rem",
      backgroundSize: "140px 140px",
    },
    backgroundSize: "335px 335px",
    background: "url(/animations/infinity-spinner.svg) center center no-repeat",
  },
}));

const Testimonial = (props) => {
  const classes = useStyles();

  const [dState, setDState] = React.useState(false);

  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div
          className={classes.overlayContainer}
          onClick={() => {
            setDState(true);
          }}
        >
          <img
            src={
              props.thumbnailLink
                ? props.thumbnailLink
                : "/images/icons/testimonials/saranya-and-govindh.webp"
            }
            alt={AppConfig.imageAltText}
            width={100}
            height={100}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.testimonialIcon}
          />
          <div className={classes.overlay}>
            <img
              src="/images/icons/social/youtube-logo.svg"
              alt={AppConfig.imageAltText}
              width={50}
              height={50}
              loading="lazy"
              referrerPolicy="no-referrer"
              className={classes.youtubeIcon}
            />
            <img
              src="/images/icons/social/play-icon.svg"
              alt={AppConfig.imageAltText}
              width={50}
              height={50}
              loading="lazy"
              referrerPolicy="no-referrer"
              className={classes.playIcon}
            />
          </div>
        </div>
        <Typography
          variant="body2"
          component="span"
          className={classes.testimonialTitle}
        >
          {props.title ? props.title : "Saranya & Govindh"}
        </Typography>
        <Typography
          variant="body2"
          component="span"
          className={classes.testimonialSubtitle}
        >
          {props.subTitle
            ? props.subTitle
            : "Starting from the booking to the registration regardless of any number of queries, we were able to reach out to them."}
        </Typography>
      </div>
      <Dialog
        open={dState}
        onClose={() => {
          setDState(false);
        }}
      >
        <iframe
          className={classes.videoSizer}
          src={
            props.youtubeLink
              ? props.youtubeLink
              : "https://www.youtube.com/embed/Caj1Ak_sV_4"
          }
          loading="lazy"
          title={props.title ? props.title : "Saranya & Govindh"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </Dialog>
    </React.Fragment>
  );
};

export default Testimonial;
